<script lang="ts" setup>
defineProps<{
  subject: string
}>()
</script>

<template>
  <strong class="select-none text-2xl font-medium text-main-dark md:text-3xl lg:text-[40px]">
    {{ subject }}
  </strong>
</template>
